import { useAiTodayStats } from "@/hooks/useAiUsage";

export default function AiGenelDurum() {
  const { data: stats, loading, error, reload } = useAiTodayStats();

  const cards = [
    {
      icon: "ri-chat-3-line",
      label: "Bugünkü AI çağrısı",
      value: stats ? stats.totalCalls.toLocaleString("tr-TR") : "—",
    },
    {
      icon: "ri-group-line",
      label: "Aktif AI kullanıcısı",
      value: stats ? stats.activeUsers.toLocaleString("tr-TR") : "—",
    },
    {
      icon: "ri-timer-line",
      label: "Ortalama yanıt süresi",
      value: stats ? `${(stats.avgLatencyMs / 1000).toFixed(1)} sn` : "—",
    },
    {
      icon: "ri-error-warning-line",
      label: "Başarı oranı",
      value: stats ? `%${stats.successRate}` : "—",
    },
  ];

  if (loading) {
    return (
      <div className="rounded-lg border border-background-200 bg-background-50 p-10 flex items-center justify-center text-foreground-500">
        <i className="ri-loader-4-line text-xl animate-spin mr-2" aria-hidden="true"></i>
        <span className="text-sm">İstatistikler yükleniyor...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-lg border border-background-200 bg-background-50 p-10 flex flex-col items-center justify-center text-center">
        <p className="text-sm text-foreground-600">{error}</p>
        <button
          type="button"
          onClick={reload}
          className="mt-4 inline-flex items-center gap-2 whitespace-nowrap px-4 py-2 rounded-md text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
        >
          <i className="ri-refresh-line" aria-hidden="true"></i>
          Tekrar dene
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((s) => (
          <div
            key={s.label}
            className="rounded-lg border border-background-200 bg-background-50 p-5"
          >
            <div className="flex items-center justify-between">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className={`${s.icon} text-lg`} aria-hidden="true"></i>
              </span>
            </div>
            <p className="mt-4 font-heading font-semibold text-2xl text-foreground-950">{s.value}</p>
            <p className="mt-1 text-sm text-foreground-500">{s.label}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="rounded-lg border border-background-200 bg-background-50 p-6">
          <h3 className="font-heading font-semibold text-base text-foreground-950">Model Kullanım Oranları</h3>
          {stats && stats.modelUsage.length > 0 ? (
            <ul className="mt-5 space-y-4">
              {stats.modelUsage.map((m) => (
                <li key={m.model}>
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-foreground-700 break-all mr-3">{m.model}</span>
                    <span className="text-foreground-500 whitespace-nowrap">
                      {m.calls.toLocaleString("tr-TR")} çağrı · %{m.percent}
                    </span>
                  </div>
                  <div className="mt-1.5 h-2 rounded-full bg-background-200 overflow-hidden">
                    <div
                      className="h-full rounded-full bg-accent-500"
                      style={{ width: `${m.percent}%` }}
                    ></div>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="mt-4 text-sm text-foreground-500">Bugün henüz AI çağrısı yapılmadı.</p>
          )}
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 p-6">
          <h3 className="font-heading font-semibold text-base text-foreground-950">Bugünkü Özet</h3>
          <dl className="mt-4 space-y-2 text-sm">
            <div className="flex justify-between gap-4">
              <dt className="text-foreground-500">Toplam çağrı</dt>
              <dd className="text-foreground-800">{stats ? stats.totalCalls.toLocaleString("tr-TR") : "—"}</dd>
            </div>
            <div className="flex justify-between gap-4">
              <dt className="text-foreground-500">Aktif kullanıcı</dt>
              <dd className="text-foreground-800">{stats ? stats.activeUsers.toLocaleString("tr-TR") : "—"}</dd>
            </div>
            <div className="flex justify-between gap-4">
              <dt className="text-foreground-500">Toplam token</dt>
              <dd className="text-foreground-800">{stats ? stats.totalTokens.toLocaleString("tr-TR") : "—"}</dd>
            </div>
            <div className="flex justify-between gap-4">
              <dt className="text-foreground-500">Ort. yanıt süresi</dt>
              <dd className="text-foreground-800">{stats ? `${(stats.avgLatencyMs / 1000).toFixed(1)} sn` : "—"}</dd>
            </div>
            <div className="flex justify-between gap-4">
              <dt className="text-foreground-500">Başarı oranı</dt>
              <dd className="text-foreground-800">{stats ? `%${stats.successRate}` : "—"}</dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
}